import { Component, DoCheck, ElementRef, inject, Injector, signal, ViewContainerRef } from "@angular/core";

import {
    LiquidElementImage,
    LiquidElementText,
    LiquidElementVideo,
    LiquidElementTypes,
    LiquidElementPdf,
} from "../liquid-page.models";
import {
    LiquidTextComponent,
    LiquidImageComponent,
    LiquidVideoComponent,
    LiquidPdfComponent,
} from "./types/liquid-element-types.index";

@Component({
    selector: 'meta-liquid-element',
    templateUrl: './liquid-element.component.html',
    styleUrls: ['./liquid-element.component.css'],
})
export class LiquidElementComponent implements DoCheck {
    vcr = inject(ViewContainerRef);
    injector = inject(Injector);

    $element = signal<LiquidElementTypes | undefined>(undefined);
    $handled = signal<boolean>(false);

    constructor(
        public elRef: ElementRef,
    ) { }

    ngDoCheck(): void {
        if (!this.$handled()) {
            this.render();
            this.$handled.set(true);
        }
    }

    render() {
        let compRef;

        switch (this.$element()?.type) {
            case 'text':
                compRef = this.vcr.createComponent(LiquidTextComponent, { injector: this.injector });
                compRef.instance.$input.set(this.$element() as LiquidElementText);
                break;

            case 'image':
                compRef = this.vcr.createComponent(LiquidImageComponent, { injector: this.injector });
                compRef.instance.$input.set(this.$element() as LiquidElementImage);
                break;

            case 'video':
                compRef = this.vcr.createComponent(LiquidVideoComponent, { injector: this.injector });
                compRef.instance.$input.set(this.$element() as LiquidElementVideo);
                break;

            case 'pdf':
                compRef = this.vcr.createComponent(LiquidPdfComponent, { injector: this.injector });
                compRef.instance.$input.set(this.$element() as LiquidElementPdf);
                break;
        }

        if (compRef) {
            this.elRef.nativeElement.replaceWith(compRef.location.nativeElement);
        } else {
            const spanElement = document.createElement('span');
            spanElement.innerHTML = `Tipologia non riconosciuta - Type: ${this.$element()?.type} - ID: ${this.$element()?.id}`;
            this.elRef.nativeElement.replaceWith(spanElement);
        }
    }
}